import { Message, MessageCallback, ResponseCallback } from '@augloop/session-protocol';
import { CorrelationVector } from '@augloop/logging/dist/src/client/logging';

import { ISessionManager } from './isession-manager';
import { EventEmitter } from 'eventemitter3';
import { SessionState } from './session-states';

export class EmptySessionManager extends EventEmitter implements ISessionManager {
    public init(): Promise<void> {
        return Promise.resolve();
    }

    public sendMessage(_message: Message, _onResponse?: ResponseCallback): void {
    }

    public onMessage(_messageType: string, _messageCallback: MessageCallback): void {
    }

    public forceReconnect(): Promise<void> {
        return Promise.resolve();
    }

    public closeSession(): void {
    }

    public sendBytes(_buffer: Uint8Array): void {
    }

    public getCorrelationVector(): CorrelationVector {
        return new CorrelationVector();
    }

    public setState(_newState: SessionState): void {
    }
}
